






















import {
  Component,
  Vue,
} from "../vuepack";
import LoginWrapper from "@/shared/components/ui/LoginWrapper.vue";
import Button from "@/shared/components/ui/Button.vue";
import {
  LoginMethod,
  MfaStatusEnum
} from "../types";
import * as routes from "@/employee/route-names";
import { LoginRouteNames } from "../loginRoutes";
import { isMobileApp } from "@/shared/mobileHelper";
import { ERROR_MESSAGE_BIOMETRIC_LOGIN_FAILED } from "../store/biometricAuth";
import { useBiometricAuthStore } from "@/shared/store/biometricAuth";
import { useUserStore } from "@/shared/store/user";
import { useMfaStore } from "@/shared/store/mfa";
import { useNotifierStore } from "@/shared/store/notifier";

@Component({
  components: {
    LoginWrapper,
    Button,
  },
})
export default class BiometricAuthLogin extends Vue {
  bioMetricAuthStore = useBiometricAuthStore();
  userStore = useUserStore();
  mfaStore = useMfaStore();
  notifierStore = useNotifierStore();

  setupBiometricAuth = false;
  routes = routes;

  mounted () {
    if (isMobileApp()) {
      document.addEventListener("deviceready", this.onDeviceReady, false);
    }
  }

  onDeviceReady () {
    this.bioMetricAuthStore.loadBiometricSettings();
  }

  loginWithBiometricAuth () {
    this.bioMetricAuthStore.getLoginCreds()
    .then((result: { username: string, password: string }) => {
      this.userStore.setLoginMethod(LoginMethod.Biometrics);
      return this.userStore.login({ username: result.username, password: result.password, logoutOnStart: true })
      .then(_ => {
        if (this.mfaStore.mfaStatus === MfaStatusEnum.Disabled) {
          return;
        }
        this.$router
          .push({
            name: LoginRouteNames.MfaVerify,
            params: {
              Username: result.username,
              Password: result.password,
              MfaType: this.mfaStore.mfaStatus
            }
          });
      });
    })
    .catch(_ => {
      this.bioMetricAuthStore.disableBiometricAuth()
      .then(() => {
        this.notifierStore.setInfo(ERROR_MESSAGE_BIOMETRIC_LOGIN_FAILED);
        this.bioMetricAuthStore.loadBiometricSettings();
      });
    });
  }
}
